import React, { useState, useEffect } from "react";
import ResizePanel from "react-resize-panel";
import styled from "styled-components";

import AlimtalkLeftSideComponent from "./components/AlimtalkLeftSideComponent";
import LoadingComponent from "./components/LoadingComponent";

import "./css/common.css";
import "./css/layout.css";
import { targetCrops } from "./data/fireblightOptionData";
import {
  getFBSpotsAlimtalk,
  getSigunguList,
} from "./context/api_alimtalk";
import AlimtalkRightSideComponent from "./components/AlimtalkRightSideComponent";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;

const ContentsWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
`;

const LeftContentsWrapper = styled.div`
  box-sizing: border-box;
  min-width: 560px;
  height: 100%;
  padding-right: 10px;
`;

const RightContentsWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;


function AlimtalkPage() {
  const today = new Date();
  const minDate = new Date("2026-01-01");

  const [error, setError] = useState("에러");
  const [loading, setLoading] = useState(true);
  const [totalSpots, setTotalSpots] = useState([]);
  const [targetCrop, setTargetCrop] = useState(targetCrops[0]);
  const [targetYear, setTargetYear] = useState(today.getFullYear());
  const [sigunguList, setSigunguList] = useState([{ region: 'all', regionDesc: "전체" }]);
  const [targetRegion, setTargetRegion] = useState(sigunguList[0]);
  const [selectedSpot, setSelectedSpot] = useState(null);

  useEffect(() => {
    getSigunguList(
      (data) => {
        setSigunguList(data);
        setTargetRegion(data[0]);
      },
      (e) => setError(e)
    );
  }, []);

  return (
    <>
      {loading ? <LoadingComponent /> : null}
      <Wrapper>
        <ContentsWrapper>
          <ResizePanel direction="e" style={{ zIndex: 2 }}>
            <LeftContentsWrapper>
              <AlimtalkLeftSideComponent
                setError={setError}
                setLoading={setLoading}
                targetCrop={targetCrop}
                targetYear={targetYear}
                targetRegion={targetRegion}
                selectedSpot={selectedSpot}
                setSelectedSpot={setSelectedSpot}
              />
            </LeftContentsWrapper>
          </ResizePanel>
          <RightContentsWrapper>
            <AlimtalkRightSideComponent
              setError={setError}
              setLoading={setLoading}
              minDate={minDate}
              today={today}
              totalSpots={totalSpots}
              setTotalSpots={setTotalSpots}
              targetCrop={targetCrop}
              setTargetCrop={setTargetCrop}
              targetYear={targetYear}
              setTargetYear={setTargetYear}
              sigunguList={sigunguList}
              targetRegion={targetRegion}
              setTargetRegion={setTargetRegion}

              getFBSpots={getFBSpotsAlimtalk}
              selectSpot={setSelectedSpot}
            />
          </RightContentsWrapper>
        </ContentsWrapper>
      </Wrapper>
    </>
  );
}

export default AlimtalkPage;
